import React, { FC, useCallback, useMemo, useState } from 'react';

import { EvConfirm, EvToast, IEvConfirmProps } from '@evinced-private/ui-common';

import { AlertPopup, IAlertPopup } from '../../components/common/alert-popup/AlertPopup';

import { ILocalEvToastProps, NotificationsContext } from './NotificationsContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NotificationsProvider: FC<{ children: any }> = ({ children }) => {
	const [isOpened, setOpened] = useState(false);
	const [errorDetails, setErrorDetails] = useState<IAlertPopup>();

	// EvToast states
	const [isEvToastOpened, setEvToastOpened] = useState<boolean>(false);
	const [toastDetails, setToastDetails] = useState<ILocalEvToastProps>();

	// EvConfirm states
	const [isEvConfirmOpened, setEvConfirmOpened] = useState<boolean>(false);
	const [confirmDetails, setConfirmDetails] = useState<IEvConfirmProps>();

	const onErrorPopupClosed = useCallback((): void => {
		setErrorDetails(null);
		setOpened(false);
	}, []);

	const value = useMemo(() => {
		return {
			alert: (errorDetails: IAlertPopup) => {
				setErrorDetails(errorDetails);
				setOpened(true);
			},
			toast: (toastDetails: ILocalEvToastProps) => {
				setToastDetails(toastDetails);
				setEvToastOpened(toastDetails.show);
			},
			confirm: (confirmDetails: IEvConfirmProps) => {
				setConfirmDetails(confirmDetails);
				setEvConfirmOpened(true);
			}
		};
	}, []);

	const onOk = useCallback((): void => {
		if (errorDetails.onOK) {
			errorDetails.onOK();
		}
		onErrorPopupClosed();
	}, [errorDetails, onErrorPopupClosed]);

	return (
		<NotificationsContext.Provider value={value}>
			{children}
			{isOpened && (
				<AlertPopup
					isOpened={isOpened}
					title={errorDetails.title}
					errorMessage={errorDetails.errorMessage}
					serverError={errorDetails.serverError}
					serverErrors={errorDetails.serverErrors}
					onOK={onOk}
				/>
			)}
			{isEvToastOpened && (
				<EvToast
					announcement={toastDetails.announcement}
					status={toastDetails.status}
					show={isEvToastOpened}
					onToastClose={() => setEvToastOpened(false)}
				/>
			)}
			{isEvConfirmOpened && (
				<EvConfirm
					{...confirmDetails}
					isControlled={true}
					isOpen={isEvConfirmOpened}
					onConfirm={(closeModal) => {
						setEvConfirmOpened(false);
						confirmDetails.onConfirm(closeModal);
					}}
					onClose={() => {
						setEvConfirmOpened(false);
					}}
				/>
			)}
		</NotificationsContext.Provider>
	);
};
